module.exports = __webpack_public_path__ + "img/icon_contact.d1c56d0c.svg";